export default __webpack_public_path__ + "static/5-a2ff19e92adf3a2ff396e5c2ef1ff376.svg";